module.exports = __webpack_public_path__ + "img/authorized-app.b57f252e.svg";